<template>
    <div class="main homepage-layout pb-8">
        <BlogPageBuilder :response="response"></BlogPageBuilder>
    </div>
</template>

<script>
import { BlogPageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'GrowersPage',
    data() {
        return {
            page_title: 'Growers',
            response: [],
        };
    },
    created() {
        getButterCmsPage('growers').then((res) => this.response = res);
    },
    components: {
        BlogPageBuilder,
    },
};
</script>
